<template>
  <div>
    <div class="title">奖励领取</div>
    <van-cell-group class="form">
      <van-field v-model.trim="form.receiveName" :clearable="true" label="收件人" placeholder="请输入收件人" />
      <van-field v-model.trim="form.receiveAddr" :clearable="true" label="收件地址" placeholder="请输入收件地址"/>
      <van-field v-model.trim="form.receivePhone" :clearable="true" label="手机号" placeholder="请输入手机号" />
    </van-cell-group>
    <p class="desc">*请正确填写真实收件信息，否则将无法收到奖品</p>
    <div class="form-button">
      <van-button type="primary" :class="(form.receiveName.length!=0 && form.receiveAddr.length!=0 && form.receivePhone.length!=0)?'btn-canclick':'btn-cantclick'"
        class="bg-green btn-confirm" @click="submit">确认无误，提交</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Toast, Field } from "vant";
import { saveRankRewardInfo } from "../api/api-activity";
export default {
  name: "rankreward",
  computed: {
    ...mapState({

    })
  },
  data() {
    return {
      form:{
        receiveName:"",
        receiveAddr:"",
        receivePhone:""
      }
    };
  },
  created() {
    console.log("rankreward")
  },
  methods: {
    submit(){
      if(!this.form.receiveName || !this.form.receiveAddr || !this.form.receivePhone){
        Toast.fail("请输入全部信息");
        return false
      }

      if(this.form.receivePhone.length > 150){
        Toast.fail("输入的收件地址太长");
        return false
      }
      if(this.form.receiveAddr.length > 100){
        Toast.fail("输入的收件人太长");
        return false
      }
      if(!(this.form.receivePhone.match(/^1[3456789]\d{9}$/))){
        Toast.fail("请输入正确的手机号码");
        return false
      }

      if(!this.$route.query.auth || !this.$route.query.activityMonth || !this.$route.query.rewardId
        || this.$route.query.auth.length == 0 || this.$route.query.activityMonth.length == 0
        || this.$route.query.rewardId.length == 0 || (this.$route.query.isBuy==1 && (!this.$route.query.orderNo || this.$route.query.orderNo.length == 0))){

        Toast.fail("请重新扫码");
        return false
      }

      localStorage.setItem('watch_auth',this.$route.query.auth);
      console.log("watch_auth "+localStorage.getItem('watch_auth'));
      this.form.activityMonth = this.$route.query.activityMonth;
      this.form.rewardId = this.$route.query.rewardId;
      this.form.isBuy = this.$route.query.isBuy;
      this.form.orderNo = this.$route.query.orderNo;

      saveRankRewardInfo(this.form).then(res=>{
        if(res.code == 200){
          Toast.success('保存成功');
        }else{
          Toast.fail(res.msg);
        }
      })
    },
  }
};
</script>
<style scoped lang="less">
.title{
  font-size:20px;
  font-weight:500;
  color:rgba(51,51,51,1);
  text-align: center;
  padding: 30px 0;
}
.desc{
  font-size:10px;
  color:red;
  text-align: center;
  padding: 15px 0;
}
.span_desc{
    color:red;
}
.van-cell-group{
  width: 100%
}
.van-field /deep/ .van-field__label{
  font-size:15px;
  font-weight:400;
  color:rgba(51,51,51,1);
  width: 80px;
}
.van-cell{
  width: auto;
  height: 50px;
  padding: 10px 0;
  margin: 0 20px
}

.btn-canclick{
  background:rgba(135,226,205,1);
  border: none;
  color: #fff
}
.btn-cantclick{
  background:rgba(225,224,225,1);
  border: none;
  color: #fff
}
.btn-getcode{
  border-radius: 20px
}
.btn-confirm{
  bottom: 40px;
  width: 335px;
  left:20px;
  color: #fff;
  font-size: 16px;
  border-radius:22px;
  margin: 80px auto
}
</style>
